<ng-container *ngIf="status">
  <section
    *ngIf="status === 'loginerror'"
    class="login-message error-bg"
    data-test="loginerror-message"
    [cignaTrackInit]="[
      'trackServiceError',
      'pkmslogin.form',
      {
        status: '302',
        errMsg:
          'HPDIA0200W Authentication failed. You have used an invalid user name, password or client certificate.'
      },
      'The User ID and password combination you entered does not match our records.',
      'event3'
    ]"
  >
    <div class="login-message-inner">
      <cigna-icon
        type="exclamation-circle"
        class="login-message-icon error-icon"
      ></cigna-icon>
      <div>
        <header class="cg-margin-bottom-sm"><h4>Login error</h4></header>
        <div>
          The User ID and password combination you entered does not match our
          records. Try again or call Customer Support at 888.736.7499.
        </div>
      </div>
    </div>
  </section>
  <section
    *ngIf="status === 'logout'"
    class="login-message info-bg"
    data-test="logout-message"
  >
    <div class="login-message-inner">
      <cigna-icon
        type="info-circle"
        class="login-message-icon info-icon"
      ></cigna-icon>
      <div>
        <header class="cg-margin-bottom-sm">
          <h4>You have logged out</h4>
        </header>
        <div>
          Thanks for visiting Provider.Evernorth.com. As a security practice,
          please close your browser. This will help protect content from any
          unauthorized users.
        </div>
      </div>
    </div>
  </section>
  <section
    *ngIf="status === 'error'"
    class="login-message info-bg"
    data-test="error-message"
  >
    <div class="login-message-inner">
      <cigna-icon
        type="info-circle"
        class="login-message-icon info-icon"
      ></cigna-icon>
      <div>
        <header class="cg-margin-bottom-sm"><h4>Error</h4></header>
        <div>
          Thanks for visiting Provider.Evernorth.com. As a security practice,
          please close your browser. This will help protect content from any
          unauthorized users.
        </div>
      </div>
    </div>
  </section>
  <section
    *ngIf="status === 'lockout'"
    class="login-message info-bg"
    data-test="lockout-message"
  >
    <div class="login-message-inner">
      <cigna-icon
        type="info-circle"
        class="login-message-icon info-icon"
      ></cigna-icon>
      <div>
        <header class="cg-margin-bottom-sm"><h4>We're Sorry</h4></header>
        <div>
          To keep your information secure, Cigna restricts the number of
          attempts to gain access to an account. You have exceeded the number of
          incorrect log in attempts allowed.<br /><br />
          Please try again in one hour. If you need site access immediately,
          please call Cigna Customer Support at 800.261.6232. We’re available 24
          hours a day, 365 days a year.
        </div>
      </div>
    </div>
  </section>
  <section
    *ngIf="status === 'timeout'"
    class="login-message info-bg"
    data-test="timeout-message"
  >
    <div class="login-message-inner">
      <cigna-icon
        type="info-circle"
        class="login-message-icon info-icon"
      ></cigna-icon>
      <div>
        <header class="cg-margin-bottom-sm"><h4>Timeout</h4></header>
        <div>
          Due to 30 minutes of inactivity, you’ve been logged out. Thank you for
          visiting Provider.Evernorth.com.
        </div>
      </div>
    </div>
  </section>
</ng-container>
